export default {
  'invoiceTaxes.label.icms': 'Valor ICMS',
  'invoiceTaxes.label.icmsSt': 'Valor ICMS ST',
  'invoiceTaxes.label.ipi': 'Valor IPI',
  'invoiceTaxes.label.issqn': 'Valor ISSQN',
  'invoiceTaxes.label.fcp': 'Valor FCP',
  'invoiceTaxes.label.fcpSt': 'Valor FCP ST',
  'invoiceTaxes.label.fcpStRetained': 'Valor FCP ST Retido',
  'invoiceTaxes.label.pis': 'Valor PIS',
  'invoiceTaxes.label.pisSt': 'Valor PIS ST',
  'invoiceTaxes.label.pisRetained': 'Valor PIS Retido',
  'invoiceTaxes.label.cofins': 'Valor COFINS',
  'invoiceTaxes.label.cofinsSt': 'Valor COFINS ST',
  'invoiceTaxes.label.cofinsRetained': 'Valor COFINS Retido',

  'invoiceTaxes.button.calculate': 'Calcular Tributos',

  'invoiceTaxes.label.others': 'Outros',
  'invoiceTaxes.label.issqn': 'ISSQN',
  'invoiceTaxes.label.issqnRate': 'Alíquota ISSQN',
  'invoiceTaxes.label.issqnCalculationBasis': 'Base de Cálculo ISSQN',
  'invoiceTaxes.label.issqnValue': 'Valor ISSQN',
  'invoiceTaxes.label.inssValue': 'Valor INSS',
  'invoiceTaxes.label.csllValue': 'Valor CSLL',
  'invoiceTaxes.label.irValue': 'Valor IR',
};
